import { useState } from 'react';
import { PageShell, SlidePanel } from '@/shared/components';
import { SeatsTable } from '@/features/accountability/components/SeatsTable';
import { SeatPanel } from '@/features/accountability/components/SeatPanel';
import type { Seat } from '@/features/accountability/types';

const PANEL_KEY = 'atek_seats_panel_width';

export function HrisSeatsPage() {
  const [selectedSeat, setSelectedSeat] = useState<Seat | null>(null);
  const [panelOpen, setPanelOpen] = useState(false);

  const openSeat = (seat: Seat) => {
    setSelectedSeat(seat);
    setPanelOpen(true);
  };
  const closePanel = () => setPanelOpen(false);

  return (
    <PageShell>
      <div className="flex min-h-[calc(100vh-240px)]">
        <div className="flex-1 min-w-0 overflow-auto">
          <SeatsTable onRowClick={openSeat} />
        </div>
        <SlidePanel open={panelOpen} storageKey={PANEL_KEY}>
          {selectedSeat && (
            <SeatPanel
              key={selectedSeat.id}
              seat={selectedSeat}
              onClose={closePanel}
            />
          )}
        </SlidePanel>
      </div>
    </PageShell>
  );
}
